/* Diffuser Bundle: full-screen "double the oil" offer (owner 2026-10-17: "focus on 2x offer after add to cart… highlight $30…
   compared to buying just 60ml… 1 click impulse decision… 60ml is average 1 month… different psychological levers… right after
   add to cart and before the bundle creating animation… full screen").
   Shown once per box, only when the box is 60ml and every scent comes in 120ml. Yes → the box switches to 120ml and goes to the
   cart; No thanks → the box goes to the cart as is; × / Escape → back to the review. Numbers come from the live box (window.APTB).
   Levers (owner: keep it short, no wordy lines): saving vs two 60ml, their own scents growing, time (60ml ≈ 30 days, the store's
   own "30-Day Use" badge), social proof (33.5% of oil reorders size up, Shopify orders to 2026-10-17). */
(function () {
  var T = window.APTB; if (!T || !T.box) return;
  // LIVE for everyone (owner 2026-10-17 "take it live"; was flagged behind ?upsize=1). ?upsize=0 switches it off for that
  // browser session (to see the old flow), ?upsize=1 switches it back on.
  var FLAG = 'apTbUpsizeOff', q = new URLSearchParams(location.search).get('upsize');
  try { if (q === '0') sessionStorage.setItem(FLAG, '1'); if (q === '1') sessionStorage.removeItem(FLAG); } catch (e) {}
  var off = false; try { off = sessionStorage.getItem(FLAG) === '1'; } catch (e) {}
  if (off) return;
  document.documentElement.classList.add('ups-flag');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function (v) { return T.fmt(v).replace(/\.00$/, ''); }, esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  // Owner 2026-10-17 ("appeared for 1st bundle add, not for second"): offered on every box add. The only skip: right after the
  // shopper taps × on it, the next Add to cart goes straight through.
  var skip = false;
  var ARR = '<svg viewBox="0 0 24 12" aria-hidden="true"><path d="M1 6h21M17 1.5 22 6l-5 4.5"/></svg>';

  window.APTBUpsize = {
    intercept: function (proceed) {
      var b = T.box();
      if (skip) { skip = false; return false; }
      if (b.size !== '60' || b.n < 3 || !b.lines.length) return false;
      if (b.lines.some(function (l) { return !l.p60 || !l.p120; })) return false;
      open(b, proceed); return true;
    }
  };

  function open(b, proceed) {
    var n = b.n, delta = 0, save = 0, p60 = b.lines[0].p60, p120 = b.lines[0].p120;
    b.lines.forEach(function (l) { delta += l.q * (l.p120 - l.p60); save += l.q * (2 * l.p60 - l.p120); });
    var shots = []; b.lines.forEach(function (l) { for (var i = 0; i < l.q && shots.length < 5; i++) shots.push(l); });
    var more = n - shots.length;
    var el = document.createElement('div');
    el.className = 'ups'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'ups-h');
    el.innerHTML = '<div class="ups__in">' +
      '<button type="button" class="ups__x" data-ups="back" aria-label="Back to my box"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg></button>' +
      '<p class="ups__eye">Before we pack your box</p>' +
      '<h2 class="ups__h" id="ups-h">Double your oil.<br><em>Save ' + fmt(save) + '.</em></h2>' +
      '<div class="ups__bottles" style="--n:' + shots.length + '">' + shots.map(function (l, i) {
        // Owner 2026-10-17: "show discount of 10 on each bottle, 60 scratched off" (exact saving vs two 60ml: $9.99).
        return '<figure style="--i:' + i + '"><span class="ups__img"><img src="' + esc(l.img) + '" alt="" width="200" height="200"><em>−' + fmt(2 * l.p60 - l.p120) + '</em></span>' +
          '<span class="ups__ml"><s>60ml</s> <b>120ml</b></span><figcaption>' + esc(l.name) + '</figcaption></figure>';
      }).join('') + (more > 0 ? '<span class="ups__more">+' + more + '</span>' : '') + '</div>' +
      '<div class="ups__time" aria-label="How long your box lasts">' +
        // Owner 2026-10-17: "lasts about 3 months", no month names.
        '<div class="ups__bar"><span>60ml</span><i><u style="--w:50%"></u></i><b>Lasts about ' + n + ' month' + (n > 1 ? 's' : '') + '</b></div>' +
        '<div class="ups__bar is-up"><span>120ml</span><i><u style="--w:100%"></u></i><b>Lasts about ' + 2 * n + ' months <em>+' + n + ' month' + (n > 1 ? 's' : '') + '</em></b></div>' +
        '<small>60ml ≈ 1 month of everyday use</small>' +
      '</div>' +
      '<p class="ups__facts"><b>1 in 3</b> repeat customers size up</p>' +
      '<div class="ups__cta">' +
        // Owner 2026-10-17 "focus on the benefits, not on the price increase": the button sells the benefit; the new total stays
        // visible (quietly) so the one-tap change is never a surprise at checkout.
        '<button type="button" class="ups__yes" data-ups="yes">Yes, double my oil</button>' +
        '<small><b>Lasts about ' + 2 * n + ' months</b> · new total ' + fmt(b.pay + delta) + '</small>' +
        '<button type="button" class="ups__no" data-ups="no">No thanks, keep 60ml</button>' +
      '</div></div>';
    document.body.appendChild(el);
    document.documentElement.classList.add('ups-open');
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    var yes = el.querySelector('.ups__yes'); setTimeout(function () { yes.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    T.track('tier_bundle_upsize_view', { n: n, delta: +delta.toFixed(2), save: +save.toFixed(2) });
    var close = function (then) {
      el.classList.remove('is-on'); el.classList.add('is-out');
      document.removeEventListener('keydown', key);
      setTimeout(function () { el.remove(); document.documentElement.classList.remove('ups-open'); if (then) then(); }, reduce ? 0 : 260);
    };
    var key = function (e) { if (e.key === 'Escape') { T.track('tier_bundle_upsize_back', { n: n }); skip = true; close(); } };
    document.addEventListener('keydown', key);
    el.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ups]'); if (!a) return;
      var act = a.dataset.ups;
      if (act === 'yes') { T.track('tier_bundle_upsize_accept', { n: n, delta: +delta.toFixed(2) }); yes.disabled = true; el.classList.add('is-yes'); T.upsize(); setTimeout(function () { close(proceed); }, reduce ? 0 : 650); }
      else if (act === 'no') { T.track('tier_bundle_upsize_decline', { n: n }); close(proceed); }
      else { T.track('tier_bundle_upsize_back', { n: n }); skip = true; close(); }
    });
  }
})();
